import './STabs.css';
import React from 'react';

export enum BookingTab {
  UPCOMING = 'upcoming',
  PAST = 'past',
  CANCELED = 'canceled',
}

interface STabsProps {
  activeTab: BookingTab;
  onTabChange: (tab: BookingTab) => void;
}

const STabs: React.FC<STabsProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { key: BookingTab.UPCOMING, label: 'Upcoming' },
    { key: BookingTab.PAST, label: 'Past' },
    { key: BookingTab.CANCELED, label: 'Canceled' },
  ];

  return (
    <div className="s-tabs-wrapper">
      <div className="s-tabs-container">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`s-tab ${activeTab === tab.key ? 's-tab--active' : ''}`}
            onClick={() => onTabChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default STabs;
